import { Component, OnInit } from '@angular/core';
import { AggregatedMeteredDataDataDto, AggregatedMeteredDataDto, SettlementService } from '@app/api/dmc';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { TabComponent } from '@shared/components/tabs/tab/tab.component';
import { Columns } from '@shared/interfaces/table/column-config';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { TableComponent } from '@shared/components/table/table.component';
import { ValueDetailsComponent } from '@shared/components/value-details/value-details.component';
import {
  settlementMeteredMasterdata
} from '@shared/modals/settlement/settlement-metered-view-modal/settlement-metered.masterdata';
import { quantityQualityPartial } from '@shared/partials/quantity-quality.partial';
import { DATE_TIME_FORMAT } from '@app/core/constants/date-time-format';

@Component({
  selector: 'app-settlement-metered-view-modal',
  imports: [
    TabsComponent,
    TabComponent,
    TableComponent,
    ValueDetailsComponent
  ],
  templateUrl: './settlement-metered-view-modal.component.html',
  styleUrl: './settlement-metered-view-modal.component.css'
})
export class SettlementMeteredViewModalComponent implements OnInit {

  public meteredElement?: AggregatedMeteredDataDto;

  public id?: string;

  public tableConfig: TableConfig<AggregatedMeteredDataDataDto> = {
    pageSize: 100,
    columns: [
      {
        title: 'settlement.metered.view.day',
        key: 'position',
        cellRenderer: DateCellComponent,
        cellRendererParams: {
          format: DATE_TIME_FORMAT,
        }
      },
      {
        title: 'settlement.metered.view.quantity',
        key: 'quantity',
      },
      quantityQualityPartial,
    ]
  }

  public tableData: AggregatedMeteredDataDataDto[] = [];

  public detailMasterdata: Columns<AggregatedMeteredDataDto>[] = settlementMeteredMasterdata;

  constructor(
    private readonly settlementService: SettlementService
  ) {
  }

  public ngOnInit(): void {
    if (this.id) {
      this.settlementService.settlementGetAggregatedMeteredDataGet(this.id).subscribe((result: AggregatedMeteredDataDto) => {
        this.meteredElement = result;
        this.tableData = result.timeSeries ?? [];
      })
    }
  }
}
